export const toPng = (data) => {
  const image = { ...data };
  if (image.logoBase64) {
    image.logoBase64 = `data:image/png;base64,${data.logoBase64}`;
  }
  return image;
};

export const base64ToPng = (base64) => {
  const image = `data:image/png;base64,${base64}`;
  return image;
};

export const getImage = (data) => {
  const image = { ...data };
  if (image.logoBase64) {
    image.logoBase64 = image.logoBase64.substr(image.logoBase64.indexOf(',') + 1);
  }
  return image;
};

export const transformLogo64 = (file) => {
  if (file && file instanceof Blob) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = error => reject(error);
    });
  }
  return null;
};
